module.exports = __webpack_public_path__ + "static/media/AAVE.aadf289d.svg";